import { useCallback, useState } from 'react';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import {
  RadioFilterValue,
  RADIO_FILTER_VALUE_MAP,
  RADIO_FILTER_VALUE_REVERSE_MAP,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants/radioFilters';

const PERPETUAL_OPTIONS = [
  { value: RadioFilterValue.Include, label: 'Include perpetual' },
  { value: RadioFilterValue.Exclude, label: 'Exclude perpetual' },
  { value: RadioFilterValue.Only, label: 'Perpetual Only' },
];

const usePerpetualFilter = () => {
  const { localFilters, setLocalFilters } = useCorporateBondScreenerSidebarFilterContext();
  const [selectedValue, setSelectedValue] = useState(
    () => RADIO_FILTER_VALUE_REVERSE_MAP.get(localFilters.perpetual) ?? RadioFilterValue.Include,
  );

  const onChange = useCallback((value: string): void => {
    setSelectedValue(value);
    setLocalFilters((prev) => ({ ...prev, perpetual: RADIO_FILTER_VALUE_MAP[value] }));
  }, [setLocalFilters]);

  return { selectedValue, onChange, options: PERPETUAL_OPTIONS };
};

export default usePerpetualFilter;
